import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {Agenda} from '../models/agenda';
import {Department} from '../models/department';
import {Activity, Topic} from '../models/event';
import {Member} from '../models/member';
import {lastValueFrom} from 'rxjs';
import {SpinnerService} from '../shared/waiting/spinner.service';


@Injectable({
  providedIn: 'root'
})
export class PublishV2Service {

  public currentPublishCollection = 'sbccv_congress_published';
  public countries = [];

  constructor (
    private db: AngularFirestore,
    private _spinnerService: SpinnerService
  ) { }

  async getPublishData (key: string, isCongress: any) {
    const waiting = this._spinnerService.show();
    // console.log("getPublishData key: " + key)
    // console.log("getPublishData isCongress: " + isCongress)
    try {
      const masterEvent = await this.getMasterEventByKey(key);
      const master = masterEvent[ 0 ];
      //  console.log('master: ' + JSON.stringify(master))
      const locations = await this.getLocations(master.location_id);
      const events = await this.getEventsInContext(master, isCongress);
      const agenda = await this.getAgendaByEvents(events)
      const days = await this.getDaysByEvents(events);
      const activities = await this.getActivitiesByEvents(events)
      const topics = await this.getTopicsByEvents(events)
      const staffMembers = await this.getStaffMembers();
      const rooms = await this.getLocationById(master.location_id);
      const deptos = await this.getDeptosByContext(master.context_id);
      const countries = await this.getCountries();
      //
      // console.log("isCongress >>> : " + isCongress)
      if (isCongress == 'true') {
        // console.log("é congresso -----------")
        return {master, events, locations, agenda, days, activities, topics, staffMembers, rooms, deptos, countries} // events,
      } else {
        // console.log("não é congresso -----------")
        const param = {'id': '1234'};
        return {master, events, locations, agenda, days, activities, topics, staffMembers, rooms, deptos, countries} // events,
      }

    } catch (err: any) {
      console.log("erro: " + err.message)
    } finally {
      waiting.close();
    }
  }

  async getSpeakersData (master: any, agenda: any[], activities: any[], locations: any[], staffSpeakers: any[], countries: any[]) {
    const waiting = this._spinnerService.show();
    // console.log("countries: " + JSON.stringify(countries))
    try {
      const agendaSpeakers = await this.getSpeakersInAgenda(agenda);

      agendaSpeakers.forEach((item: any) => {
        if (!item.state) item.state = '';

        const data = staffSpeakers.find((speaker) => speaker.id == item.id);
        if (!data) {
          console.warn(`Speaker sem dados de staff encontrado na agenda: ${ item.id } - ${ item.name }`);
        }

        item.key = master.key;
        item.context_id = master.context_id;
        item.state = data?.state ?? item.state ?? '';

        item.country = data?.country ? data.country : 'Brasil';
        // console.log(item.country)
        const flag = countries.find((e) => {
          return e.country == item.country;
        })
        item.flag = flag ? flag.image : "";

        item.text = data?.text ?? '';
        item.image = data?.image ?? '';


        const speakerNotesInAgenda = agenda.filter((e) => e.member_id == item.id);
        const speakerActivities: any[] = [];
        const speakerTopics: any[] = [];

        speakerNotesInAgenda.forEach((spa) => {
          const activity = activities.find((e) => e.id == spa.activity_id);

          if (!activity) {
            console.warn(`Atividade não encontrada para o palestrante ${ item.id } na agenda ${ spa.id }`);
            return;
          }

          spa.sponsors = activity.sponsors;
          spa.location_id = activity.location_id ? activity.location_id : '-';

          const location = locations.find((e) => e.id == spa.location_id);
          if (!location) {
            console.warn(`Localização não encontrada para speaker ${ item.id } em location_id ${ spa.location_id }`);
            spa.location = 'Local não informado';
            return;
          }

          spa.location = location.name.substring(4, location.lenght);

          if (spa.level == 'a') {
            speakerActivities.push(spa);
          } else if (spa.level == 't') {
            speakerTopics.push(spa);
          }
        });

        speakerActivities.sort(this.compareStartTime);
        speakerTopics.sort(this.compareStartTime);

        item.activities = speakerActivities;
        item.topics = speakerTopics;
      });

      return agendaSpeakers;
    } catch (err: any) {
      console.error('Erro em getSpeakersData:', {
        context_id: master.context_id,
        agendaLength: agenda?.length ?? 0,
        activitiesLength: activities?.length ?? 0,
        locationsLength: locations?.length ?? 0,
        staffSpeakersLength: staffSpeakers?.length ?? 0,
        message: err?.message,
        stack: err?.stack,
        err
      });
      throw err;
    } finally {
      waiting.close();
    }
  }

  async _getMasterEventByKey (key: string): Promise<any[]> {
    try {
      const querySnapshot = await lastValueFrom(
        this.db.collection<any>('sbccv_events', ref => ref
          .where('key', '==', key)
          .where('master', '==', true)
        ).get()
      );

      if (!querySnapshot) {
        return [];
      }

      return querySnapshot.docs.map((doc: any) => ({
        id: doc.id,
        name: doc.data().name,
        context_id: doc.data().context_id,
        key: doc.data().key,
        location_id: doc.data().location_id,
        startDay: doc.data().startDay,
        image_web: doc.data().image_web,
      }));
    } catch (error) {
      console.error('Erro getMasterEvent: ', error);
      throw error;
    }
  }

  async getMasterEventByKey (key: string): Promise<any[]> {
    // console.log("getMasterEventByKey: " + key)
    try {
      const querySnapshot = await lastValueFrom(
        this.db.collection<any>('sbccv_events', ref => ref
          .where('key', '==', key)
          .where('master', '==', true)
        ).get()
      );

      if (!querySnapshot) {
        return [];
      }

      return querySnapshot.docs.map((doc: any) => ({
        id: doc.id,
        name: doc.data().name,
        context_id: doc.data().context_id,
        key: doc.data().key,
        location_id: doc.data().location_id,
        startDay: doc.data().startDay,
        image_web: doc.data().image_web,
        master: doc.data().master,
      }));
    } catch (error) {
      console.error('Erro getMasterEvent: ', error);
      throw error;
    }
  }

  async getLocations (id: string): Promise<any[]> {

    try {
      const querySnapshot = await lastValueFrom(
        this.db.collection<any>('sbccv_convention_centers')
          .doc(id)
          .get()
      );

      const data = querySnapshot.data();
      return data && Array.isArray(data.rooms) ? data.rooms : [];
      //
    } catch (error) {
      console.error("Erro getMasterEvent: ", error);
      throw error;
    }
  }

  async getEventsInContext (master: any, isCongress: any): Promise<any[]> {
    try {
      const context_id = master.context_id
      const key = master.key

      let querySnapshot: any;

      // console.log("getEventsInContext context_id: " + context_id)
      // console.log("getEventsInContext isCongress: " + isCongress)
      //  console.log("getEventsInContext key: " + key)

      if (isCongress == 'true') {
        querySnapshot = await lastValueFrom(
          this.db.collection<any>('sbccv_events', ref => ref
            .where('congress', '==', true)
            .where('context_id', '==', context_id)
          ).get()
        );
      } else {
        querySnapshot = await lastValueFrom(
          this.db.collection<any>('sbccv_events', ref => ref
           //.where('congress', '==', isCongress)
            .where('key', '==', key)
          ).get()
        );
      }

      if (!querySnapshot) {
        return [];
      }

     return await querySnapshot.docs.map((doc: any) => ({
        id: doc.id,
        name: doc.data().name,
        context_id: doc.data().context_id,
        key: doc.data().key,
        location_id: doc.data().location_id,
        startDay: doc.data().startDay,
      }));

    } catch (error) {
      console.error('Erro getEventsInContext: ', error);
      throw error;
    }
  }

  async getAgendaByEvents (events: any[]): Promise<any[]> {
    const array: any[] = [];

    // 1. Criamos as promessas para buscar as agendas em paralelo
    const promises = events.map(event => {
      return lastValueFrom(
        this.db.collection<Agenda>('sbccv_agenda', ref => ref
          .where('event_id', '==', event.id)
          .orderBy('day_date')
        ).get()
      ).catch(error => {
        console.error(`Erro ao buscar agenda para o evento ${ event.id }:`, error);
        return null;
      });
    });

    // 2. Executa todas as consultas simultaneamente
    const snapshots = await Promise.all(promises);

    // 3. Processa os resultados
    for (const querySnapshot of snapshots) {
      if (!querySnapshot) continue;

      querySnapshot.forEach(doc => {
        const data = doc.data();

        array.push({
          id: doc.id,
          member_id: data.member_id,
          member_name: data.member_name,
          member_state: data.member_state ? data.member_state : 'SP',
          member_country: data.member_country ? data.member_country : "Brasil",
          day_id: data.day_id,
          day_date: this.formatDate_DD_MM(data.day_date),
          activity_id: data.activity_id,
          activity_name: data.activity_name,
          // Simplificação do ternário usando o operador de coalescência nula (??)
          topic_id: data.topic_id ?? "",
          topic_name: data.topic_name ?? "",
          role_id: data.role_id,
          role_name: data.role_name,
          level: data.level,
          activity_startTime: data.activity_startTime ?? "",
          topic_startTime: data.topic_startTime ?? "",
          topic_duration: data.topic_duration ?? "",
        });
      });
    }

    array.sort(this.compareAgendaNames)
    return array;
  }

  async getActivitiesByEvents (events: any[]): Promise<any[]> {
    const activityArray: any[] = [];

    // 1. Criamos um array de Promises para buscar todas as atividades simultaneamente
    const promises = events.map(event => {
      return lastValueFrom(
        this.db.collection('sbccv_event_activities', ref => ref
          .where('deleted', '==', false)
          .where('event_id', '==', event.id)
        ).get()
      ).catch(error => {
        console.error(`Erro ao buscar atividades para o evento ${ event.id }:`, error);
        return null;
      });
    });

    // 2. Aguardamos o retorno de todas as consultas de uma vez
    const snapshots = await Promise.all(promises);

    // 3. Processamos os resultados acumulando no array final
    for (const querySnapshot of snapshots) {
      if (!querySnapshot) continue;

      querySnapshot.forEach((doc: any) => {
        const data = doc.data();

        // console.log("data: " + JSON.stringify(data))

        activityArray.push({
          id: doc.id,
          day_id: data.day_id,
          name: data.name,
          date: this.formatDate_DD_MM(data.date),
          sponsors: data.sponsors,
          location_id: data.location_id,
          depto_id: data.depto_id,
          event_id: data.event_id,
          depto: data.depto,
          location: data.location,
          startTime: data.startTime,
          agenda: []
        });
      });
    }

    return activityArray;
  }

  async getTopicsByEvents (events: any[]): Promise<any[]> {
    const topicsArray: any[] = [];

    // 1. Criamos as promessas para buscar todos os tópicos em paralelo
    const promises = events.map(event => {
      return lastValueFrom(
        this.db.collection('sbccv_event_topics', ref => ref
          .where('deleted', '==', false)
          .where('event_id', '==', event.id)
        ).get()
      ).catch(error => {
        console.error(`Erro ao buscar tópicos para o evento ${ event.id }:`, error);
        return null;
      });
    });

    // 2. Aguardamos todas as consultas finalizarem simultaneamente
    const snapshots = await Promise.all(promises);

    // 3. Processamos os resultados acumulando no array
    for (const querySnapshot of snapshots) {
      if (!querySnapshot) continue;

      querySnapshot.forEach((doc: any) => {
        const data = doc.data();

        topicsArray.push({
          id: doc.id,
          activity_id: data.activity_id,
          day_id: data.day_id,
          name: data.name,
          duration: data.duration,
          event_id: data.event_id,
          startTime: data.startTime,
          agenda: []
        });
      });
    }

    // 4. Ordenação final (importante manter após o loop de preenchimento)
    topicsArray.sort(this.compareTimes);

    return topicsArray;
  }

  async getSpeakersInAgenda (agenda: any): Promise<any[]> {

    const arraySpeakers: any[] = []
    arraySpeakers.push({"id": "-Todos os palestrantes", "name": "-Todos os palestrantes"})
    //console.log(JSON.stringify(agenda))
    agenda.forEach((item) => {
      if (item.member_name !== "A DEFINIR") {
        const exist = arraySpeakers.find((e) => {
          return e.id == item.member_id
        })
        if (!exist) {
          /*
          const flag = countries.find((e)=>{
            return e.country == item.member_country; 
          })
            */
          arraySpeakers.push({
            "id": item.member_id,
            "name": item.member_name,
          })
        }
      }
    })
    arraySpeakers.sort(this.compareNames)
    return arraySpeakers;
  }

  async getStaffMembers (): Promise<any[]> {
    try {
      const querySnapshot = await lastValueFrom(
        this.db.collection<any>('sbccv_members', ref => ref
          .where('staff', '==', true)
          .orderBy('name', 'asc')
        ).get()
      );

      if (!querySnapshot) {
        return [];
      }

      return querySnapshot.docs.map((doc: any) => {
        const data = doc.data();

        return {
          id: doc.id,
          name: data.name,
          state: data.state,
          country: data.country,
          image: data.image,
          text: data.text,
        };
      });
    } catch (error) {
      console.error('Erro ao buscar staff members:', error);
      throw error;
    }
  }

  async getDeptosByContext (context_id: any): Promise<any[]> {
    const deptoArray: any[] = [
      {"id": "-Todas as atividades", "short": "-Todas as atividades"}
    ];

    try {
      // 1. Substituímos .toPromise() pelo lastValueFrom
      // A query já possui orderBy, então os resultados já virão ordenados do Firebase
      const querySnapshot = await lastValueFrom(
        this.db.collection<Department>('sbccv_departments', ref => ref
          .where("context_id", "==", context_id)
          .orderBy('short', 'asc')
        ).get()
      );

      // 2. Processamos os documentos
      querySnapshot.forEach(doc => {
        const data = doc.data();

        deptoArray.push({
          id: doc.id,
          name: data.name,
          short: data.short,
          text: data.text,
        });
      });

    } catch (error) {
      // 3. Em caso de erro (como falta de índice no Firestore para o orderBy), 
      // registramos no console e retornamos o array com o valor padrão.
      console.error(`Erro ao buscar departamentos para o contexto ${ context_id }:`, error);
    }

    return deptoArray;
  }

  async getDaysByEvents (events: any[]): Promise<any[]> {
    const dayArray: any[] = [
      {id: "999", date: "-Todos os dias"}
    ];

    // 1. Mapeamos os eventos para uma lista de Promises (execução paralela)
    const promises = events.map(async event => {
      try {
        return await lastValueFrom(
          this.db.collection('sbccv_event_days', ref_1 => ref_1
            .where('event_id', '==', event.id)
            .orderBy('date', 'asc')
          ).get()
        );
      } catch (error) {
        console.error(`Erro ao buscar dias para o evento ${ event.id }:`, error);
        return null;
      }
    });

    // 2. Aguardamos todas as consultas finalizarem
    const snapshots = await Promise.all(promises);

    // 3. Processamos os resultados
    for (const querySnapshot of snapshots) {
      if (!querySnapshot) continue;

      querySnapshot.forEach((doc: any) => {
        const data = doc.data();
        const dt = this.formatDate_DD_MM(data.date);

        // Verifica se a data já foi adicionada ao array para evitar duplicatas
        const alreadyExists = dayArray.some(e => e.date === dt);

        if (!alreadyExists) {
          dayArray.push({
            id: doc.id,
            event_id: data.event_id,
            name: data.name,
            date: dt
          });
        }
      });
    }

    return dayArray;
  }

  async getLocationById (location_id: any): Promise<any[]> {
    const roomsArray: any[] = [
      {"id": "-Todas as salas", "name": "0 - -Todas as salas"}
    ];

    try {
      // 1. Substituição do .toPromise() por lastValueFrom
      // Note que usamos .doc() para buscar um documento específico
      const docSnapshot = await lastValueFrom(
        this.db.doc<any>(`sbccv_convention_centers/${ location_id }`).get()
      );

      const data = docSnapshot.data();

      // 2. Verificamos se o documento existe e se possui o array de salas
      if (data && data.rooms && Array.isArray(data.rooms)) {
        data.rooms.forEach((room: any) => {
          roomsArray.push({
            id: room.id,
            name: room.name
          });
        });
      }

      // 3. Opcional: Ordenar as salas por nome após o preenchimento
      // roomsArray.sort((a, b) => a.name.localeCompare(b.name));

      return roomsArray;

    } catch (error) {
      console.error(`Erro ao buscar salas para o local ${ location_id }:`, error);
      // Retornamos o array apenas com o valor padrão em caso de erro para não quebrar o componente
      return roomsArray;
    }
  }

  async getCountries () {
    try {
      const array: any = [];

      const querySnapshot = await lastValueFrom(
        this.db.collection<any>('sbccv_countries', ref => ref
          .orderBy('country', 'asc')
        ).get()
      );

      // 2. Processamos os documentos
      querySnapshot.forEach(doc => {
        const data = doc.data();
        array.push({
          country: data.country,
          image: data.image,
        });
      });
      //
      this.countries = array;
      return array;
      //
    } catch (error) {
      // 3. Em caso de erro (como falta de índice no Firestore para o orderBy), 
      // registramos no console e retornamos o array com o valor padrão.
      console.error(`Erro ao carregar coungtries`, error);
    }

  }

  async makeListOfActivities (master: any, data: any) {
    // 1. Criamos Mapas de busca rápida para evitar usar .find() dentro do loop
    const roomsMap = new Map(data.rooms.map((r: any) => [ r.id, r.name ]));
    const deptoMap = new Map(data.deptos.map((d: any) => [ d.id, d ]));

    // 2. Pré-agrupamos tópicos e agenda por ID para evitar .filter() dentro do loop
    const topicsByActivity = this.groupBy(data.topics, 'activity_id');
    const agendaByTopic = this.groupBy(
      data.agenda.filter((ag: any) => ag.level === 't'),
      'topic_id'
    );
    const agendaByActivity = this.groupBy(
      data.agenda.filter((ag: any) => ag.level === 'a'),
      'activity_id'
    );

    // 3. Processamos as atividades de forma linear O(n)
    const result = data.activities.map((activity: any) => {
      // Busca rápida no Map (O(1))
      activity.location = roomsMap.get(activity.location_id) || activity.location;

      const depto: any = deptoMap.get(activity.depto_id);
      if (depto) {
        activity.depto = depto.short;
        activity.depto_text = depto.text;
      } else {
        console.log("não achou depto: " + activity.depto_id);
      }

      // Busca tópicos pré-agrupados
      const topics = topicsByActivity.get(activity.id) || [];

      // Processa agenda dos tópicos
      topics.forEach((topic: any) => {
        const topicAgenda = agendaByTopic.get(topic.id) || [];
        topic.agenda = topicAgenda.sort(this.compareAgendaNames);
      });

      // Atribui propriedades finais
      activity.key = master.key;
      activity.context_id = master.context_id;
      activity.topics = topics;

      const activityAgenda = agendaByActivity.get(activity.id) || [];
      activity.agenda = activityAgenda.sort(this.compareAgendaNames);

      return activity;
    });

    // 4. Ordenação final
    return result.sort(this.compareDateAndStartTime);
  }


  compareStartTime (a: any, b: any) {

    const _a = a.day_date + a.activity_startTime + a.topic_startTime;
    const _b = b.day_date + b.activity_startTime + b.topic_startTime

    if (_a > _b) return 1;
    if (_b > _a) return -1;

    return 0;

  }

  /**
   * Função utilitária para agrupar arrays por uma chave (muito performática)
   */
  private groupBy (array: any[], key: string): Map<string, any[]> {
    const map = new Map<string, any[]>();
    array.forEach(item => {
      const group = item[ key ];
      if (!map.has(group)) map.set(group, []);
      map.get(group)!.push(item);
    });
    return map;
  }

  selectByKey (key: any) {
    return this.db.collection<Event>('sbccv_events', ref => ref
      //.where('congress', '==', false)
      //.where('deleted', '==', false)
      .where('key', '==', key)
    ).get()
  }

  getDays (event_id: any) {
    return this.db.collection<Event>('sbccv_event_days', ref => ref
      .where('event_id', '==', event_id)
      .where('deleted', '==', false)
    ).get()
  }

  async getAgenda (event_id) {
    return this.db.collection<Agenda>('sbccv_agenda', ref => ref
      .where('event_id', '==', event_id)
      .orderBy('day_date')
    ).get();
  }

  async getDeptos () {
    return this.db.collection<Department>('sbccv_departments', ref => ref.orderBy('short', 'asc')).get();
  }

  async getLocation (location_id: any) {
    return this.db.doc<Location>('sbccv_convention_centers/' + location_id)
      .get();
  }

  async getTopics (event_id) {
    return this.db.collection<Topic>('sbccv_event_topics', ref => ref
      .where('deleted', '==', false)
      .where('event_id', '==', event_id)
    ).get();
  }

  compareNames (a, b) {
    if (a.name > b.name) return 1;
    if (b.name > a.name) return -1;
    return 0;
  }

  compareMemberNames (a, b) {
    if (a.member_name > b.member_name) return 1;
    if (b.member_name > a.member_name) return -1;
    return 0;
  }

  compareAgendaNames (a, b) {
    var itemA = a.role_name.toUpperCase() + a.member_name.toUpperCase();
    var itemB = b.role_name.toUpperCase() + b.member_name.toUpperCase();
    if (itemA > itemB) return 1;
    if (itemB > itemA) return -1;
    return 0;
  }

  compareLocations (a: any, b: any) {

    const da = a.location;
    const db = b.location;

    if (da > db) return 1;
    if (db > da) return -1;

    return 0;
  }
  compareDateAndStartTime (a: any, b: any) {

    const da = a.date + a.startTime + a.location;
    const db = b.date + b.startTime + b.location;

    if (da > db) return 1;
    if (db > da) return -1;

    return 0;

  }

  compareDayAndTime (a: any, b: any) {

    const da = new Date(a.date)
    const db = new Date(b.date)

    const _a = da.getTime() + a.startTime.replace(':', '')
    const _b = db.getTime() + b.startTime.replace(':', '')

    if (_a > _b) return 1;
    if (_b > _a) return -1;

    return 0;

  }


  compareDays (a, b) {
    let _a = a.date
    let _b = b.date
    if (_a > _b) return 1;
    if (_b > _a) return -1;
    return 0;
  }


  compareTimes (a, b) {
    let _a = a.startTime
    let _b = b.startTime
    if (_a > _b) return 1;
    if (_b > _a) return -1;
    return 0;
  }

  formatDate (date: any) {
    if (date) {
      let dt: Date = date.toDate()
      let dd: any = dt.getDate()
      let mm: any = dt.getMonth() + 1
      let yy: any = dt.getFullYear()

      if (dd.toString().length < 2) dd = "0" + dd
      if (mm.toString().length < 2) mm = "0" + mm

      return dd + "/" + mm + "/" + yy
    } else {
      return ""
    }
  }

  formatDate_DD_MM (dt: any) {

    if (!dt) {
      return ""
    }

    //const date: Date = new Date(dt)
    const date: Date = dt.toDate();

    const dd = date.getDate()
    const MM = date.getMonth() + 1

    let mm: string = MM.toString()

    if (mm.length < 2)
      mm = "0" + MM

    return dd + "/" + mm

  }

  getSpeakerData (member_id) {
    return this.db.doc<Member>('sbccv_members/' + member_id)
      .get();
  }
  //

  getSpeaker (speaker_id) {
    return this.db.doc<Member>('sbccv_speakers_published/' + speaker_id)
      .get();
  }





  async removeActivity (event_id) {

    const deletePromise = new Promise(async (resolve, reject) => {
      return this.db.collection<any>(this.currentPublishCollection, ref => ref
        .where('event_id', '==', event_id))
        .get()
        .subscribe(async (result) => {

          for (let i = 0; i < result.docs.length; i++) { //
            const item_id = result.docs[ i ].id

            await this.db.collection<any>(this.currentPublishCollection)
              .doc(item_id)
              .delete()
              .then(() => {
              })
              .catch(() => {
                console.log('delete ERROR: ' + JSON.stringify(item_id))
              })

          }

          resolve(true)
        })
    })
    return Promise.all([ deletePromise ])

  }

  publishSchedule (activity: any) {
    return this.db.collection(this.currentPublishCollection).doc(activity.id).set(Object.assign({}, activity), {'merge': true});
  }

  getSchedule (event_id) {
    return this.db.collection(this.currentPublishCollection, ref => ref
      .where('event_id', '==', event_id)
      .orderBy('date', 'asc')
      .orderBy('startTime', 'asc'))
      .get();
  }

  makeSchedule (data: any) {

    const entity = {
      "id": data.id,
      "name": data.name,
      "date": data.date,
      "date_dd_mm": this.formatDate_DD_MM(data.date),
      "day_id": data.day_id,
      "depto_id": data.depto_id,
      "depto": data.depto,
      "event_id": data.event_id,
      "location_id": data.location_id,
      "location": data.location,
      "startTime": data.startTime,
      'sponsor': data.sponsors[ 0 ] ? data.sponsors[ 0 ] : null,
      "agenda": [],
      "topics": []
    }

    entity.agenda = []
    data.agenda.forEach((aga) => {
      entity.agenda.push({
        "id": aga.id,
        "member_id": aga.member_id,
        "member_name": aga.member_name,
        "day_id": aga.day_id,
        "activity_id": aga.activity_id,
        "role_id": aga.role_id,
        "role_name": aga.role_name,
        "level": aga.level
      })
    })

    entity.topics = []
    data.topics.forEach((topic) => {

      const topic_agenda: any[] = []

      topic.agenda.forEach((agt) => {
        topic_agenda.push({
          "id": agt.id,
          "member_id": agt.member_id,
          "member_name": agt.member_name,
          "day_id": agt.day_id,
          "activity_id": agt.activity_id,
          "topic_id": agt.topic_id,
          "role_id": agt.role_id,
          "role_name": agt.role_name,
          "level": agt.level
        })
      })

      entity.topics.push({
        "id": topic.id,
        "activity_id": topic.activity_id,
        "event_id": topic.event_id,
        "name": topic.name,
        "day_id": topic.day_id,
        "duration": topic.duration,
        "startTime": topic.startTime,
        "agenda": topic_agenda
      })

    })

    return entity;

  }

  checkSpeakers (speakers) {
    speakers.forEach((speaker) => {

      this.getSpeaker(speaker.id)
        .subscribe((result) => {

          if (result.exists) {
            console.log(JSON.stringify(result.data()))
          } else {

            this.getSpeakerData(speaker.id)
              .subscribe((res) => {

                this.publishSpeaker({
                  'id': res.id,
                  'name': res.data().name,
                  'image': res.data().image,
                  'text': res.data().text
                })
                  .then(() => { })
                  .catch(() => {console.log('erro ao atualizar publish speakers')})
              })
          }

        })
    })

  }

  publishSpeaker (data: any) {
    return this.db.collection('sbccv_speakers_published').doc(data.id).set(Object.assign({}, data), {'merge': true});
  }

  getPublishedCollection () {
    return this.db.collection(this.currentPublishCollection).get();
  }


  async clearSpeakersAgenda (context_id: string): Promise<boolean> {
    const waiting = this._spinnerService.show();

    try {
      // 1. Busca os documentos (usando lastValueFrom para evitar o deprecated)
      const querySnapshot = await lastValueFrom(
        this.db.collection("pub_guest_agenda", ref =>
          ref.where('context_id', '==', context_id)
        ).get()
      );

      if (querySnapshot.empty) return true;

      const docs = querySnapshot.docs;
      const totalDocs = docs.length;
      const batchLimit = 500; // Limite oficial do Firebase

      // 2. Loop para processar os documentos em grupos de 500
      for (let i = 0; i < totalDocs; i += batchLimit) {
        const batch = this.db.firestore.batch();

        // Obtém o próximo pedaço (chunk) de 500 documentos
        const chunk = docs.slice(i, i + batchLimit);

        chunk.forEach(doc => {
          batch.delete(doc.ref);
        });

        // Comita o lote atual antes de ir para o próximo
        await batch.commit();
        console.log(`Lote processado clearSpeakersAgenda: documentos ${ i + 1 } a ${ Math.min(i + batchLimit, totalDocs) }`);
      }

      return true;
    } catch (error) {
      console.error('Error in clearSpeakersAgenda:', error);
      return false;
    } finally {
      waiting.close();
    }
  }

  async publishSpeakersAgenda (activities: any): Promise<boolean> {
    //
    const waiting = this._spinnerService.show();
    //
    try {
      //
      // 1. Cria um array de promises para todas as operações de inserção

      const activitiesArray = activities.slice(1);
      //
      const publishPromises = activitiesArray.map(entry =>
        this.db.collection("pub_guest_agenda")
          .add({...entry})
      );

      // 2. Aguarda todas as inserções serem concluídas
      await Promise.all(publishPromises);

      return true;
      //
    } catch (error) {
      console.error('Error publishing speakersAgenda:', error);
      return false;
    } finally {
      waiting.close()
    }

  }

  async clearActivities (context_id: string): Promise<boolean> {
    const waiting = this._spinnerService.show();

    try {
      // 1. Busca os documentos (usando lastValueFrom para evitar o deprecated)
      const querySnapshot = await lastValueFrom(
        this.db.collection('pub_guest_activities', ref =>
          ref.where('context_id', '==', context_id)
        ).get()
      );

      if (querySnapshot.empty) return true;

      const docs = querySnapshot.docs;
      const totalDocs = docs.length;
      const batchLimit = 500; // Limite oficial do Firebase

      // 2. Loop para processar os documentos em grupos de 500
      for (let i = 0; i < totalDocs; i += batchLimit) {
        const batch = this.db.firestore.batch();

        // Obtém o próximo pedaço (chunk) de 500 documentos
        const chunk = docs.slice(i, i + batchLimit);

        chunk.forEach(doc => {
          batch.delete(doc.ref);
        });

        // Comita o lote atual antes de ir para o próximo
        await batch.commit();
        console.log(`Lote processado: documentos ${ i + 1 } a ${ Math.min(i + batchLimit, totalDocs) }`);
      }

      return true;
    } catch (error) {
      console.error('Error in clearActivities:', error);
      return false;
    } finally {
      waiting.close();
    }
  }

  async publishActivities (activities: any[]): Promise<boolean> {
    const waiting = this._spinnerService.show();
    // console.log(JSON.stringify(activities))

    try {
      // 1. Cria um array de promises para todas as operações de inserção
      const publishPromises = activities.map(activity =>
        this.db.collection('pub_guest_activities')
          .add({...activity})
      );

      // 2. Aguarda todas as inserções serem concluídas
      await Promise.all(publishPromises);
      return true;
    } catch (error) {
      console.error('Error publishing activities:', error);
      return false;
    } finally {
      waiting.close()
    }
  }

}
